module.exports = __webpack_public_path__ + "img/hr-garballo-mini-dry-12.d9e8f0a9.png";